import { z } from "zod"

const zNumberOrStringToNumber = z.preprocess((val) => {
  if (val === null || val === undefined || val === "") return null
  if (typeof val === "string" && val.trim() === "") return null
  const num = Number(val)
  return Number.isNaN(num) ? null : num
}, z.number().nullable())

const zStringOrNullToString = z.preprocess(
  (val) => (val === null || val === undefined ? "" : val),
  z.string(),
)

const zNumberOrStringToNumberDefault0 = z.preprocess((val) => {
  if (val === null || val === undefined || val === "") return 0
  if (typeof val === "string") {
    const cleaned = val.replace(/\s/g, "").replace(",", ".")
    const num = Number(cleaned)
    return Number.isNaN(num) ? 0 : num
  }
  if (typeof val === "number") return val
  return 0
}, z.number())

const zIdToString = z.preprocess((val) => {
  if (val === null || val === undefined) return ""
  if (typeof val === "number") return String(val)
  if (typeof val === "string") return val
  return String(val)
}, z.string())

const zStringOrNullToStringDefaultEmpty = z.preprocess(
  (val) => (val === null || val === undefined ? "" : val),
  z.string(),
)

const zTagsOrNullToArray = z.preprocess((val) => {
  if (val === null || val === undefined) return []
  return val
}, z.array(z.string()))

export const OfferSchema = z.object({
  id: z.number(),
  CustomOfferID: zIdToString,
  Pdf: z.string().nullable(),
  Type: z.string(),
  Origin: z.string().nullable(),
  Destination: z.string().nullable(),
  OfferTitle: z.string(),
  AccommodationName: zStringOrNullToString,
  StarRating: zNumberOrStringToNumber,
  BoardBasis: z.string().nullable(),
  OfferReference: zStringOrNullToString,
  SearchType: z.string().nullable(),
  StartDate: z.string(),
  EndDate: z.string(),
  Category: z.string(),
  Description: z.string(),
  MoreInformation: z.string().nullable(),
  WhatsIncluded: zStringOrNullToString,
  Nights: zNumberOrStringToNumberDefault0,
  BasedOnAdults: z.number().nullable(),
  BasedOnChildren: z.number().nullable(),
  ImageURL: z.string(),
  URL: z.string(),
  Filename: z.string(),
  UpdatedDate: z.string().nullable(),
  tags: zTagsOrNullToArray,
  Subdominio: z.string().nullable(),
  LeadInPrice: z.string(),
  PriceType: zStringOrNullToStringDefaultEmpty,
  Thumbnail: z.string().nullable().optional(),
})

export const OffersSchema = z.array(OfferSchema)

export type Offer = z.infer<typeof OfferSchema>
export type Offers = z.infer<typeof OffersSchema>
